<section>
    <div class="container">
        <div class="title text-center">
            <h1>{{title}}</h1>
            <p>{{ 'blog.posted_on' | translate }} <span>{{date | date:'mediumDate'}}</span></p>
        </div>
        <div class="mediaImage">
            <img src="{{mainImage}}">
        </div>

        <br>

        <p>
            {{content}}
        </p>

        <br>

        <p>
            {{steps}}
        </p>

        <h2 class="mt-4">{{ 'blog.products' | translate }}</h2>

        <div class="row">
            <div class="col-6 col-md-3" *ngFor="let item of products">
                <div>
                    <img src="{{item.image[0].image_url}}">
                    <p class="text-center mt-2">
                        {{item.name}}
                    </p>
                </div>
            </div>
        </div>

        <br>
        <br>
        <hr>
        <div>
            <div class="row">
                <div class="col-12 col-md-6 text-center" *ngFor="let item of videosArr">
                    <video style="width: 100%" controls>
                        <source src="{{item.image_url}}" type="video/mp4">
                        <source src="{{item.image_url}}" type="video/ogg">
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>
